import _ from 'lodash';
import AppConstatnt from '../../config/app.constants';
const LIMIT = 10;
const MAXLIMIT = 1000;
class ShipmentBatchController {
	/*@ngInject*/
	constructor(Auth, $state, User, BatchService, DateUtil, Modal, $translate, HolidayService, CustomerService, 
				ShipmentService, $q, LocationService, LocationBranchService, ShiptypeService, RouteService, BranchService, 
				$scope, SetupService, $rootScope, DenominationService, OrderViewService, IdStoreService) {
		this.CustomerService = CustomerService
		this.BatchService = BatchService
		this.DateUtil = DateUtil
		this.ShipmentService = ShipmentService
		this.Modal = Modal
		this.$translate = $translate
		this.$q = $q
		this.User = User;
		this.LocationService = LocationService
		this.ShiptypeService = ShiptypeService
		this.RouteService = RouteService
		this.BranchService = BranchService
		this.SetupService = SetupService;
		this.HolidayService = HolidayService;
		this.$scope = $scope;
		this.LocationBranchService = LocationBranchService;
		this.$rootScope = $rootScope;
		this.$state = $state;
		this.DenominationService = DenominationService;
		this.OrderViewService = OrderViewService;
		this.IdStoreService = IdStoreService;
		window.$q = $q;

		this.areShipmentsValid = false;
		this.vaultDate = null;

		this.model = {
			branchId: this.User.getUser().branchId,
			batchMaster: '',
			location: '',
			inputType: '',
			pickupDate: null,
			deliveryDate: null,
			description: '',
			shipments: [],
			selectedFile: '',
			vaultDate: null,
			vaultDates: null,
			orderNo: null,
			duplicateTrackingIds: [],
			bankLocationDDToggle: false,
			amountToggle: false,
			autoGenerateTrackIdToggle: true,
			date: '',
			searchText: null,
			sortColumn: "batchId",
			reverseSort: false,
			coinOnlyBatch: false,
			branches: [{Value: this.User.getUser().branchId}]
		}

		this.shipment = [];
		this.pagination = {
			page: 1,
			total: 0,
			pageLimit: AppConstatnt.defaultPageLimit,
			maxPages: 10
		};

		this.bankLocationsObj = {
			offset: 0,
			limit: 1000,
			totalLocationRecords: 0,
			list: [],
			search: '',
			loadMore: this.loadMoreBankDeliverLocations
		}
		this.dateOptions = {
			deliveryDate: {
				minDate: new Date().setDate(new Date().getDate() - 1)
			}
		}
		this.routes = {
			defaultRoute: ''
		};
		this.shipmentData = [];
		this.locations = [];
		this.branches = [];
		this.batchMasters = [];
		this.uploadedFiles = [];
		this.shipTotals = [];
		this.shipmentsData = [];
		this.holidayRoutes = '';
		this.isHoliday = '';
		this.holidayStartDate = '';
		this.holidayEndDate = '';
		this.batchSourceIds;
		this.table = {
			locId: '',
			refId: '',
			currency: '',
			trackingId: '',
			coin1: '',
			coin5: '',
			coin10: '',
			coin25: '',
			coin50: '',
			coin1$: '',
			coinMisc: '',
			defaultBranch: '',
			scanLimit: '',
			routeIds: [],
			locationBranches: [],
			currentCoinNumber: null
		}
		this.minTable = 1

		this.allowUnitValues = {
			currency: false,
			coin: false,
			misc: false
		}

		this.coinValues = {};

		this.denominationTypeMapping = {
			'PENNY': {
				category: '01',
				categoryName: 'coin1',
				template: null,
				coinFlag: true,
				sortOrder: 1
			},
			'NICKEL': {
				category: '05',
				categoryName: 'coin5',
				template: null,
				coinFlag: true,
				sortOrder: 2
			},
			'DIMES': {
				category: '10',
				categoryName: 'coin10',
				template: null,
				coinFlag: true,
				sortOrder: 3
			},
			'QUARTER': {
				category: '25',
				categoryName: 'coin25',
				template: null,
				coinFlag: true,
				sortOrder: 4
			},
			'HALF_US_DOLLAR': {
				category: '50',
				categoryName: 'coin50',
				template: null,
				coinFlag: true,
				sortOrder: 5
			},
			'ONE_US_DOLLAR': {
				category: '1$',
				categoryName: 'coin1$',
				template: null,
				coinFlag: true,
				sortOrder: 6
			},
			'COIN_MISC': {
				sortOrder: 7
			}
		}

		this.coinTypes = {};
		this.releaseError = [];
		this.storageMode = false;
		this.HOLD_ROUTE = '';
		this.offset = 0;
		this.routeLocations = [];
		this.allRouteLocations = []
		this.scanLimit = "";
		this.denominationTypeData = [];
		this.$rootScope.$broadcast('routeChange', '/app/shipment-batch');
		self = this;

		this.stats = {
			deliveryShipment: 'deliveryShipment',
			atmLoads: 'atmLoads',
			completedShipment:'completedShipment'
		}
		this.currentStats = this.stats.deliveryShipment;
		this.atmLoadModel = {
			atmLoadShipment: []
		}
		this.loggedInUserId = this.User.getUser().id;
		this.deletedTrackingId=[];
	}

	isDateChanged = function (currentDate, mode) {
		if (this.model.pickupDate > this.model.deliveryDate) {
			this.model.deliveryDate = this.model.pickupDate
		}
		else if (this.model.pickupDate == null) {
			this.model.deliveryDate = null
		}
		this.deliveryDateOptions = {
			minDate: this.model.pickupDate
		};
	}

	//disabled commit button when total or trackingID null or zero
	commitDisabled() {
		var disableButton = this.model.shipments.map((cr) => {
			cr.refId = cr.refIdObj && !cr.refId ? cr.refIdObj.Value : cr.refId;
			const hasAmountErrors = cr.amountErrors && Object.keys(cr.amountErrors).length > 0;

			if (this.model.coinOnlyBatch) {
				return cr.total > 0 && cr.refId && !hasAmountErrors || 'isEmpty';
			}

			return cr.total >= 0 && cr.trackingId && cr.refId && !hasAmountErrors && !(cr.checkScanLimit && (cr.trackingId.length > cr.scanLimit)) || 'isEmpty'
		})
			.indexOf('isEmpty') !== -1;

		return disableButton
	}

	// fromLocationChanged() {
	// 	const selectedBatchType = this.batchMasters.find((batchMaster) => {
	// 		return batchMaster.batchSourceId === $scope.model.location.id;
	// 	});

	// 	if (this.model.batchMaster !== selectedBatchType.inputType) {
	// 		this.model.batchMaster = selectedBatchType.inputType;
	// 	}
	// }

	performReset() {
		this.Modal.confirm({
			header: this.$translate.instant('common.reset'),
			message: this.$translate.instant('shipmentBatch.resetData'),
			callback: ({
				modal
			}) => {
				this.resetData();
				modal.close();
			},
			type: 'danger'
		})
	}

	resetData() {
		const storageKey = this.getLocalStorageKey();
		const coinOnlyBatch = !!this.model.coinOnlyBatch;
		this.storageMode = coinOnlyBatch;

		if (this.model.selectedFile) {
			this.RouteService.unlockFile(this.model.selectedFile)
				.then(() => {
					return this.RouteService.getUploadedFiles();
				})
				.then((data) => {
					this.uploadedFiles = data.results;
				});
		}

		this.model = {
			branchId: this.User.getUser().branchId,
			batchMaster: '',
			customer: '',
			inputType: '',
			pickupDate: moment(this.vaultDate).add(1, 'second').toDate(),
			deliveryDate: moment(this.vaultDate).add(1, 'day').toDate(),
			description: '',
			shipments: [],
			selectedFile: '',
			duplicateTrackingIds: [],
			bankLocationDDToggle: false,
			amountToggle: false,
			coinOnlyBatch: coinOnlyBatch,
			autoGenerateTrackIdToggle: true,
			branches: [{Value: this.User.getUser().branchId}] 
			// trackingId: this.model.autoGenerateTrackIdToggle === false ? null:this.currentNumber
		};
		this.bankLocationsObj = {
			offset: 0,
			limit: 1000,
			totalLocationRecords: 0,
			list: [],
			search: '',
			loadMore: this.loadMoreBankDeliverLocations
		}
		localStorage.removeItem(storageKey);
		this.isRoutesSet = false;
		this.getAllBranchesList('', 0)
		this.areShipmentsValid = false;
		this.currentStats = this.stats.deliveryShipment;
		this.deletedTrackingId=[];
		for (let i = 0; i < this.minTable; i++){
			 this.add(); 
			 if(this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch){
				 this.getPreviewId()
				 .then(()=>{
					for (let i = 0; i < this.model.shipments.length; i++) {
						const data = this.model.shipments[i];
						data.trackingId =  this.setupData.trackingIdPrefix + this.currentNumberArray[i];
					}
				 }) 
			 } else if (this.model.coinOnlyBatch) {
				this.IdStoreService.getPreviewNextId('COINONLYBATCH', this.model.shipments.length + 1).then((data) => {
					this.model.shipments.forEach((shipment, index) => {
						shipment.trackingId = (data.start + index).toString();
					});
					this.model.currentCoinNumber = (data.start + this.model.shipments.length).toString();
				});
			 }
		}
		this.branchChanged();
		this.fromLocationChanged();
		this.isRoutesSet = false;
	}

	// load locationType == INTERNAL, BANK data based on BranchID With Search value
	loadLocationData() {
		const searchObj = {
			queryJSON: {
				rules: [
					{
						field: 'branchId',
						condition: '=',
						data: this.model.branches.map(ele => ele.Value)
						// data: this.model.branchId
					},
					{
						group: {
							rules: [
								{
									field: 'locationType',
									condition: '=',
									data: 'INTERNAL'
								}, {
									group: {
										rules: [
											{
												field: 'locationType',
												condition: '=',
												data: 'BANK'
											},
											{
												field: 'centralBank',
												condition: '=',
												data: true
											}
										],
										operator: 'AND'
									}
								}
							],
							operator: 'OR',
						}
					}
				],
				operator: 'AND'
			}
		};
		return searchObj ? searchObj : null;
	}

	// load locationType == INTERNAL, BANK data based on BranchID With Search value
	loadLocationDataWithSearch(searchKey) {
		const searchObj = {
			queryJSON: {
				rules: [
					{
						field: 'branchId',
						condition: '=',
						// data: this.model.branchId
						data: this.model.branches.map(ele => ele.Value)
					},
					{
						group: {
							rules: [
								{
									field: 'locationType',
									condition: '=',
									data: 'INTERNAL'
								}, {
									group: {
										rules: [
											{
												field: 'locationType',
												condition: '=',
												data: 'BANK'
											},
											{
												field: 'centralBank',
												condition: '=',
												data: true
											}
										],
										operator: 'AND'
									}
								}
							],
							operator: 'OR',
						}
					},
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "name",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: 'AND'
			}
		};
		return searchObj.queryJSON.rules.length ? searchObj : null;
	}

	$onInit(reset) {
		//
		this.loading = true;
		let batchSearchObj = {
			branchId: this.model.branchId,
			queryText: '%%',
		}

		this.data = JSON.parse(localStorage.getItem(this.getLocalStorageKey()));

		const searchObj = this.model.branchId ? {
			queryJSON: {
				rules: [
					{
						field: 'branchId',
						condition: '=',
						data: this.model.branchId
					}
				],
				operator: 'AND'
			}
		} : null;

		const denomSearchObj = {
			queryJSON: {
				rules: [
					{
						field: 'currencyId',
						condition: '=',
						data: 'USD'
					}
				],
				operator: 'AND'
			}
		};

		this.$q.all([
			this.BatchService.all(batchSearchObj, 0, MAXLIMIT),
			this.ShiptypeService.all(null, 0, MAXLIMIT),
			this.RouteService.getUploadedFiles(),
			this.BranchService.getBranchSetup(this.data && this.data.model.location ? this.data.model.location.branchId : this.model.branchId),
			this.SetupService.get(this.data && this.data.model.location ? this.data.model.location.branchId : this.model.branchId),
			this.HolidayService.getGrouped(searchObj, 0, MAXLIMIT),
			this.DenominationService.all(denomSearchObj, 0, 1000),
			this.OrderViewService.generateOrderNumber()
		])
			.then((data) => {
				this.shiptypeList = data[1].results;
				this.batchSourceIds = data[0].results
					.filter((batch) => !!batch.batchSourceId)
					.map((batch) => batch.batchSourceId);

				this.locations =this.mappingLocationDatas(data[0].results.map(res => res.batchSource)).filter((location) => this.batchSourceIds.includes(location.id) && location.centralBank)
				// this.totalLocationRecords = data[0].total;

				// this.locations = this.mappingLocationDatas(data[0].results).filter((location) => this.batchSourceIds.includes(location.id));
				this.shiptypeList.forEach((s) => {
					if (this.denominationTypeMapping[s.denominationType]) {
						this.coinTypes = Object.assign(this.coinTypes, {
							[s.denominationType]: {
								denomList: [],
								isOpen: false,
								template: `coin-selection.html`,
								selected: null,
								category: null,
								categoryName: null
							},
						})
					}
				})

				this.shiptypeList.forEach((s) => {
					if (this.denominationTypeMapping[s.denominationType]) {
						this.coinTypes[s.denominationType].denomList.push({
							icon: s.id
						})
						this.coinTypes[s.denominationType].coinFlag = true;
						this.coinTypes[s.denominationType].category = this.denominationTypeMapping[s.denominationType].category;
						this.coinTypes[s.denominationType].categoryName = this.denominationTypeMapping[s.denominationType].categoryName;
						this.coinTypes[s.denominationType].selected = this.coinTypes[s.denominationType].denomList[0].icon;
						this.coinTypes[s.denominationType].sortOrder = this.denominationTypeMapping[s.denominationType].sortOrder;
					}
				});

				Object.keys(this.coinTypes).map((key) => {
					this.denominationTypeData.push({
						group: key,
						sortOrder: this.coinTypes[key].sortOrder
					})
				})
				this.denominationTypeData = _.orderBy(this.denominationTypeData, ['sortOrder'], ['ASC']);

				this.batchMasters = data[0].results;
				this.coinValues = {};

				if (this.shiptypeList) {
					this.shiptypeList.map((shiptype) => {
						this.coinValues[shiptype.id] = {
							amountFlag: shiptype.amountFlag,
							unitValue: shiptype.unitValue,
							amount: shiptype.amount
						};
					});
				}

				this.uploadedFiles = data[2].results

				this.HOLD_ROUTE = data[3].holdRouteId

				this.holidayRoutes = data[4].useHolidayRoutes

				this.isHoliday = data[5].results
				this.vaultDate = this.DateUtil.convertToDate(data[4].currentVaultDate)
				this.scanLimit = data[4].packCharLength;
				this.atmLoadModel.denominations = data[6].results.filter(d => d.shiptypeId == 'C');
				this.atmLoadModel.nextOrderNumber = data[7].nextOrderNumber;

				this.setupData = data[4];
				this.autoGenerateToggle = this.setupData.autoGenerateTrackingId;
				setTimeout(()=>{
					if(this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch){
						this.getPreviewId().then(()=>{
							for (let i = 0; i < this.model.shipments.length; i++) {
								const data = this.model.shipments[i];
								data.trackingId =  this.setupData.trackingIdPrefix + this.currentNumberArray[i];
							}
						})
					}
					if(!this.autoGenerateToggle){
						this.model.shipments.forEach((data) => {
							this.trackingId = data.trackingId
						})
					}
					this.$scope.$apply()
				})
				this.getAllLocation('', 0);
				this.getAllBranchesList('', 0)
			})
			.catch((err) => {
				this.error = err.message
			})
			.finally(() => {
			// Initial loading
				this.loading = false;

				if (localStorage.getItem(this.getLocalStorageKey()) === null) {
					this.storageMode = !!this.model.coinOnlyBatch;
					this.resetData();
				} else {
					try {
						const storedData = JSON.parse(localStorage.getItem(this.getLocalStorageKey()));
						if (!storedData || !storedData.model) {
							this.resetData();
						} else {
							this.storageMode = !!storedData.model.coinOnlyBatch;
							this.model = {
								...storedData.model,
								coinOnlyBatch: !!storedData.model.coinOnlyBatch
							};
							this.isRoutesSet = !!storedData.isRoutesSet;
							if (storedData.coinTypes) {
								this.coinTypes = storedData.coinTypes;
							}
							this.normalizeShipmentsForMode(this.storageMode);
							this.bankLocationToggleChange();
						}
					} catch (error) {
						console.error('Error parsing local storage:', error);
						this.resetData();
					}
				}

				// Handle shipments
				if (this.model.shipments && Array.isArray(this.model.shipments)) {
					this.model.shipments.forEach((data) => {
						this.trackingId = data.trackingId;
						this.locId = data.locId;
						this.refId = data.refId;
						this.total = data.total;
						this.shipmentsData = data;
						data.scanLimit = this.scanLimit;
						data.checkScanLimit = this.scanLimit > 0;
					});
				}

				// Set dates if no shipment data exists
				if (!this.trackingId && !this.locId && !this.refId && !this.total) {
					this.model.pickupDate = moment(this.vaultDate).add(1, 'second').toDate();
					this.model.deliveryDate = moment(this.vaultDate).add(1, 'days').toDate();
				}

				this.vltDate = moment(this.vaultDate).add(1, 'second').toDate();

				this.pickupDateOptions = {
					minDate: this.vltDate
				};

				this.deliveryDateOptions = {
					minDate: this.model.pickupDate
				};

				// Watch for changes and update localStorage
				this.$scope.$watch(() => {
					const obj = {
						model: {
							...this.model,
							coinOnlyBatch: this.storageMode
						},
						isRoutesSet: this.isRoutesSet,
						coinTypes: this.coinTypes
					};

					return JSON.stringify(obj, null, 1);
				}, (newVal, oldVal) => {
					if (newVal && newVal !== oldVal) {
						this.persistToLocalStorage(this.storageMode);
					}
				});
			})

		this.obj = JSON.parse(localStorage.getItem(this.getLocalStorageKey()));
	}

	mappingLocationDatas(locations) {
		return locations.map((location) => {
			return _.merge({
				Key: location.id + " | " + location.name,
				Value: location.id
			}, location)
		});
	}

	mappingBranches(branches) {
		return branches.map((branch) => {
			return _.merge({
				Key: branch.id,
				Value: branch.id
			}, branch)
		});
	}

	batchMasterChanged() {
		if (!this.model.batchMaster) {
			return;
		}

		const selectedBatchMaster = this.model.batchMaster
		const setCoins = (coinTypes, version) => {
			if (!coinTypes || !coinTypes.length || !version) {
				return;
			}

			coinTypes.forEach((key) => {
				const coinType = this.coinTypes[key];
				if (coinType.category) {
					coinType.selected = coinType.selected.substr(0, coinType.selected.length - 1) + version;
				}
			});
		};

		switch (selectedBatchMaster[1]) {
			case 'L': {
				const keys = Object.keys(this.coinTypes);
				setCoins(keys, 'L');
				break;
			}
			case 'H': {
				const coinHKeys = ['coin10'];
				setCoins(coinHKeys, 'H');

				break;
			}
			default: {
				const keys = Object.keys(this.coinTypes);
				setCoins(keys, 'B');
				break;
			}
		}

		this.allowUnitValues = {
			currency: selectedBatchMaster[0] === 'U',
			coin: selectedBatchMaster[1] === 'U',
			misc: selectedBatchMaster[2] === 'U'
		};
	}

	onAmountToggleChange() {
		this.model.shipments.forEach((shipment) => {
			shipment.amountErrors = {};
		});
	}

	getLocalStorageKey() {
		const prefix = (this.model && this.model.coinOnlyBatch) ? 'shipment-batch-coin-' : 'shipment-batch-cash-';
		return prefix + this.User.getUser().branchId;
	}

	getLocalStorageKeyByMode(coinOnlyBatch) {
		const prefix = coinOnlyBatch ? 'shipment-batch-coin-' : 'shipment-batch-cash-';
		return prefix + this.User.getUser().branchId;
	}

	persistToLocalStorage(coinOnlyBatch = this.storageMode) {
		try {
			const obj = {
				model: {
					...this.model,
					branchId: this.User.getUser().branchId,
					coinOnlyBatch
				},
				isRoutesSet: this.isRoutesSet,
				coinTypes: this.coinTypes
			};
			localStorage.setItem(this.getLocalStorageKeyByMode(coinOnlyBatch), JSON.stringify(obj));
		} catch (error) {
			console.error('Error updating localStorage:', error);
		}
	}

	refreshCoinOnlyTrackingIds() {
		return this.IdStoreService.getPreviewNextId('COINONLYBATCH', this.model.shipments.length + 1)
			.then((data) => {
				this.model.shipments.forEach((shipment, index) => {
					shipment.trackingId = (data.start + index).toString();
				});
				this.model.currentCoinNumber = (data.start + this.model.shipments.length).toString();
			});
	}

	normalizeShipmentsForMode(coinOnlyBatch = this.model && this.model.coinOnlyBatch) {
		if (!this.model || !Array.isArray(this.model.shipments)) {
			return;
		}

		this.model.shipments.forEach((shipment, index) => {
			if (coinOnlyBatch) {
				shipment.total = this.getCoinSum(shipment);
				shipment.currency = 0;
				return;
			}

			shipment.currency = this.getCurrency(index);
		});
	}

	getCoinSum(s) {
		let coinsTotal = 0;
		const coinKeys = Object.keys(this.coinTypes);
		coinKeys.forEach((coinKey) => {
			if (!this.coinTypes[coinKey]) return;
			const coinType = this.coinTypes[coinKey].selected;
			const categoryName = this.coinTypes[coinKey].categoryName;
			if (s[categoryName]) {
				coinsTotal += s[categoryName] * this.getCoinValue(coinType);
			}
		});
		return coinsTotal;
	}

	onCoinOnlyBatchToggle() {
		const selectedMode = !!this.model.coinOnlyBatch;
		const previousMode = this.storageMode;
		const newKey = this.getLocalStorageKeyByMode(selectedMode);

		this.persistToLocalStorage(previousMode);
		const storedData = JSON.parse(localStorage.getItem(newKey));

		if (storedData && storedData.model) {
			this.storageMode = selectedMode;
			this.model = {
				...storedData.model,
				coinOnlyBatch: selectedMode
			};
			this.isRoutesSet = !!storedData.isRoutesSet;
			if (storedData.coinTypes) {
				this.coinTypes = storedData.coinTypes;
			}
			this.normalizeShipmentsForMode(selectedMode);
			if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
				this.autoGenerateTrackingToggleChange();
			}
		} else {
			this.storageMode = selectedMode;
			this.model.shipments = [];
			this.isRoutesSet = false;
			this.add();

			if (this.model.coinOnlyBatch) {
				this.IdStoreService.getPreviewNextId('COINONLYBATCH', this.model.shipments.length + 1)
					.then((data) => {
						this.model.shipments.forEach((s, i) => {
							s.trackingId = (data.start + i).toString();
						});
						this.model.currentCoinNumber = data.end.toString();
						this.normalizeShipmentsForMode(true);
					});
			} else {
				this.autoGenerateTrackingToggleChange();
				this.normalizeShipmentsForMode(false);
			}
		}
	}

	confirmRemove(index) {
		if (this.model.shipments.length === 1) {
			return this.Modal.alert({
				type: 'danger',
				header: this.$translate.instant('shipmentBatch.alertModalTitle'),
				message: this.$translate.instant('shipmentBatch.alertModalMessage'),
				callback: ({ modal }) => { modal.close(); }
			});
		}

		this.Modal.confirm({
			header: this.$translate.instant('common.confirm_delete_title'),
			message: this.$translate.instant('shipmentBatch.delete_message'),
			callback: (({
				modal,
				$scope
			}) => {
				this.remove(index)
				modal.close()
			}),
			type: 'danger'
		})
	}

	deliveryDateChanged() {
		this.isRoutesSet = false;

		this.model.shipments.forEach((shipment) => {
			shipment.routeIds = [];
			shipment.routeId = null;
		});
	}

	pickupDateChanged() {
		if (this.model.pickupDate > this.model.deliveryDate) {
			this.model.deliveryDate = moment(this.model.pickupDate).add(1, 'days').toDate();
		}
	}

	add() {
		const newShipment = angular.copy(this.table);
		this.isRoutesSet = false;
		newShipment.routeIds = [];
		newShipment.scanLimit = ''
		newShipment.checkScanLimit = ''
		// newShipment.total = 0;

		if (this.routes.defaultRoute) {
			newShipment.routeIds.push(this.routes.defaultRoute);
		}

		if (this.HOLD_ROUTE) {
			newShipment.routeIds.push('HOLD');
		}
		newShipment.routeId = newShipment.routeIds[0];
		newShipment.scanLimit = this.scanLimit;
		newShipment.checkScanLimit = newShipment.scanLimit > 0;

		if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
			newShipment.trackingId = this.setupData.trackingIdPrefix + (this.currentNumber);//this.incrementNumber
		} else if (this.model.coinOnlyBatch && this.model.currentCoinNumber) {
			newShipment.trackingId = this.model.currentCoinNumber;
		} else {
			newShipment.trackingId = null;
		}

		this.model.shipments.push(newShipment)
		setTimeout(() => {
			const locationInput = document.querySelectorAll('#showBankLocationDdInp');

			if(locationInput && locationInput[locationInput.length - 1]){
                locationInput[locationInput.length - 1].focus();
			}
			locationInput[locationInput.length - 1].focus();
		},100)
	}

	addOnTab(index) {
		if (index === this.model.shipments.length - 1) {
			if(!this.model.bankLocationDDToggle && this.model.shipments[index].refId){
				const parts = this.model.shipments[index].refId.split(' | ');
				this.fetchLocationDetails(parts[0]).then((data) => {
						if(!data.results) return
					this.model.shipments[index].refIdObj = {
						...data.results,
						Key: 'None',
						Value: 'None',
						parentLocation: this.model.location
					}
				})
			}
			if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
				if (this.deletedTrackingId && this.deletedTrackingId.length) {
					this.getPreviewId().then(() => this.add())
				}
				else if(this.model.cursor == 0 || this.model.cursor) {
					this.getAutoGeneratedTrackingId(this.model.cursor++).then(() => this.add())
				}
				else {
					this.getAutoGeneratedTrackingId(this.model.shipments.length).then(() => this.add())
				}
			}
			else if (this.model.coinOnlyBatch) {
				this.getAutoGeneratedCoinId(this.model.shipments.length).then(() => this.add());
			}
			else {
				this.add()
			}
		}
		setTimeout(() => {
			const locationInput = document.querySelectorAll('#showBankLocationDdInp');

			if(locationInput && locationInput[index+1]){
                locationInput[index+1].focus();
			}
			locationInput[locationInput.length - 1].focus();
		},100)
	}

	addOnButton() {
		if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
			if (this.deletedTrackingId && this.deletedTrackingId.length) {
				this.getPreviewId().then(() => this.add())
			}
			else if(this.model.cursor == 0 || this.model.cursor) {
				this.getAutoGeneratedTrackingId(this.model.cursor++).then(() => this.add())
			}
			else {
				this.getAutoGeneratedTrackingId(this.model.shipments.length).then(() => this.add())
			}
		}
		else if (this.model.coinOnlyBatch) {
			this.getAutoGeneratedCoinId(this.model.shipments.length).then(() => this.add());
		}
		else {
			this.add()
		}
	}

	remove(index) {
		this.deletedTrackingId.push(this.model.shipments[index].trackingId);
		this.model.shipments.splice(index, 1);
	}

	getCoinValue(coinType) {
		let batchMasterCharIndex = -1;

		if (coinType === 'total') {
			return 1;
		}

		if (coinType === 'coinMisc') {
			batchMasterCharIndex = 2;
		}
		else {
			batchMasterCharIndex = 1;
		}

		return (this.coinValues[coinType].amountFlag && this.coinValues[coinType].amount > 0) ? this.coinValues[coinType].amount : this.coinValues[coinType].unitValue;
	}

	getCurrency(index) {
		let coinsTotal = 0;
		const coinKeys = Object.keys(this.coinTypes);
		coinKeys.forEach((coinKey) => {
			if (!this.coinTypes[coinKey]) return;
			const coinType = this.coinTypes[coinKey].selected;
			const categoryName = this.coinTypes[coinKey].categoryName;
			if (this.model.shipments[index][categoryName]) {
				coinsTotal += this.model.shipments[index][categoryName] * this.getCoinValue(coinType);
			}
		});

		return this.model.shipments[index].total ? this.model.shipments[index].total - coinsTotal : - coinsTotal;
	}

	getTotalByName(coinKey, type = null) {
		let total = 0;
		this.model.shipments.forEach((shipmentBatchRecord) => {
			if (shipmentBatchRecord[coinKey]) {
				if (coinKey === 'total') {
					total += shipmentBatchRecord[coinKey];
				}
				else {
					const coinType = this.coinTypes[type].selected;
					total += shipmentBatchRecord[coinKey] * (coinKey === 'total' ? 1 : this.getCoinValue(coinType));
				}
			}
		});

		return total;
	}

	getCurrencyTotal() {
		let total = 0;
		this.areShipmentsValid = true;

		this.model.shipments.forEach((shipmentBatchRecord, index) => {
			const currency = this.getCurrency(index);

			if (currency < 0) {
				this.areShipmentsValid = false;
			}

			total += currency
		});

		return total;
	}

	getLocation(refId) {
		const searchObj = {
			queryJSON: {
				rules: [
					{
						field: 'refNumber',
						condition: '=',
						data: refId
					},
					{
						field: 'id',
						condition: '=',
						data: refId
					},
					{
						field: 'idBatchImport',
						condition: '=',
						data: refId
					}
				],
				operator: 'OR'
			}
		};

		//fetch location which has refNumber equal to refId
		return this.LocationService.all(searchObj, 0, 1);
	}

	loadRoutes() {
		const routeSearchObj = {
			queryJSON: {
				rules: [
					{
						field: 'branchId',
						condition: '=',
						data: this.model.location.branchId
						// data: this.model.branchId
					}
				],
				operator: 'AND'
			}
		};

		return this.RouteService.all(routeSearchObj, 0, MAXLIMIT)
			.then((data) => {
				this.model.holdRouteId = null;
				this.routes = data.results;
			})
			.catch(error => {
				console.log(error);
			});
	}

	getlocationBranches(locationId) {
		const locationSearchObj = {
			queryJSON: {
				rules: [
					{
						field: 'locationId',
						condition: '=',
						data: locationId
					}
				],
				operator: 'AND'
			}
		};

		return this.LocationBranchService.all(locationSearchObj, 0, 100)
	}

	setRoutes(indexesToCheck) {
		const INDEX_NOT_MENTIONED = 'index not mentioned';
		this.errorCheck = 0
		this.errorCount = 0
		this.errorNotFound = 0;
		this.errorNotFoundCount = 0
		const day = moment(this.model.deliveryDate).day();

		const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

		const routeIdField = `defRoute${weekDays[day]}Id`;
		const routeField = `defRoute${weekDays[day]}`;
		const holidayRouteId = 'defRouteHolId'
		const HolidayRoutes = 'defRouteHol'

		this.model.vaultDates = moment(this.vaultDate).day();

		// check for Holidays
		this.isHoliday.forEach((holidays) => {
			this.holidayStartDate = moment(holidays.holidayDate).day();
			this.holidayEndDate = moment(holidays.holidayEnd).day();
		})

		// check if holidayToggle true or false
		const useHolidays = this.holidayRoutes

		// check for routeId associate with different branch OR not && also check for Holiday Routes
		if (this.model.vaultDates == day && this.model.vaultDates == this.holidayStartDate
			&& this.model.location[HolidayRoutes] !== null
			&& this.model.location[HolidayRoutes].branchId === this.model.branchId && useHolidays == true) {
			this.routes.defaultRoute = this.model.location[holidayRouteId];
		}
		else if (day == this.holidayEndDate && this.holidayEndDate == this.model.vaultDates
			&& this.model.location[HolidayRoutes] !== null
			&& this.model.location[HolidayRoutes].branchId === this.model.branchId && useHolidays == true) {
			this.routes.defaultRoute = this.model.location[holidayRouteId];
		}
		else if (this.model.location[routeField] !== null && this.model.location[routeField].branchId === this.model.branchId) {
			this.routes.defaultRoute = this.model.location[routeIdField];
		}
		else {
			this.routes.defaultRoute = 'HOLD';
		}

		// this.routes.defaultRoute = this.model.location[routeIdField];

		return this.$q.all(
			this.model.shipments.map((shipment, index) => {
				if (indexesToCheck && indexesToCheck.length && !indexesToCheck.includes(index)) {
					return this.$q.when(INDEX_NOT_MENTIONED);
				}

				if (shipment.location) {
					return this.$q.when(shipment.location);
				}

				if (shipment.refId && shipment.trackingId && shipment.total > 0) {
					return this.$q.all([
						this.getLocation(shipment.refId),
						this.getlocationBranches(shipment.refId),
					])
						.then((data) => {
							this.shipmentData = data[0].results;
							this.multiBranches = this.shiptypeList.map((data => data.branchId))
							shipment.locationBranches = this.multiBranches;
							if (this.shipmentData.length) {
								this.shipmentData.forEach((data) => {
									shipment.defaultBranch = data.branchId;
									shipment.isFromOtherBranch = true;
									this.isTrue = shipment.locationBranches.includes(this.model.location.branchId);
									// this.isTrue = shipment.locationBranches.includes(this.model.branchId);
									if (!this.isTrue) {
										this.shipmentData = null;
										this.errorCheck++;
									}
									if (this.errorCheck >= 1 && this.errorCount == 0) {
										this.errorCount = 1
										return this.Modal.errorModal("error." + 90222);
									}
								})
							} else {
								shipment.isFromOtherBranch = false;
								this.shipmentData = null;
								this.errorNotFound++;
								if (this.errorNotFound >= 1 && this.errorNotFoundCount == 0) {
									this.errorNotFoundCount = 1
									this.Modal.errorModal("location.noLocations");
								}
							}
							shipment.location = this.shipmentData ? this.shipmentData[0] : null;
							return shipment.location;
						});
				}
			})
		)
			.then((locations) => {
				return locations.map((fetchedLocation) => {

					this.fetchedLocations = fetchedLocation;

					if (fetchedLocation === null || fetchedLocation === INDEX_NOT_MENTIONED) {
						return fetchedLocation;
					}
					// check for routeId associate with different branch OR not && also check for Holiday
					if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null &&
						this.model.vaultDates == this.holidayStartDate &&
						fetchedLocation[HolidayRoutes].branchId === this.model.branchId &&
						this.model.vaultDates == day && useHolidays == true) {
						return fetchedLocation[holidayRouteId];
					}
					else if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null &&
						day == this.holidayEndDate && this.holidayEndDate == this.model.vaultDates &&
						fetchedLocation[HolidayRoutes].branchId === this.model.branchId &&
						useHolidays == true) {
						return fetchedLocation[holidayRouteId];
					}
					else if (fetchedLocation != null && fetchedLocation[routeField] !== null &&
						fetchedLocation[routeField].branchId === this.model.branchId) {
						return fetchedLocation[routeIdField];
					}
				})
			})
			.then((routeIds) => {
				this.model.shipments.forEach((shipmentBatchRecord, index) => {
					if (routeIds[index] === INDEX_NOT_MENTIONED) {
						return;
					}

					const shipmentRoute = routeIds[index];

					shipmentBatchRecord.routeIds = [];

					if (this.routes.defaultRoute) {
						shipmentBatchRecord.routeIds.push(this.routes.defaultRoute);
						shipmentBatchRecord.routeId = this.routes.defaultRoute;
					}

					if (this.HOLD_ROUTE || this.fetchedLocations != null
						&& this.fetchedLocations[routeField] !== null
						&& this.fetchedLocations[routeField].branchId !== this.model.branchId) {
						shipmentBatchRecord.routeIds.push('HOLD');
						shipmentBatchRecord.routeId = 'HOLD';
					}
					if (shipmentRoute) {
						shipmentBatchRecord.routeIds.push(shipmentRoute);
						shipmentBatchRecord.routeId = shipmentRoute;
					}

					//remove dupes
					shipmentBatchRecord.routeIds = shipmentBatchRecord.routeIds.filter((routeId, index, array) => {
						return array.indexOf(routeId) === index;
					});
				});
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => {
				this.isRoutesSet = this.model.shipments.every((shipmentRecord) => {
					return !!shipmentRecord.location;
				});
			});
	}

	checkHoldAndCallSupervisor(shipments) {
		let defer = this.$q.defer();

		let needSupervisor = false;
		shipments.forEach((s) => {
			if (s.routeId === 'HOLD') {
				needSupervisor = true;
			}
		});

		if (needSupervisor) {
			this.Modal.confirmSupervisor('put-on-hold', null, ({ modal, supId }) => {
				modal.close();
				defer.resolve({ needSupervisor, supId });
			}, ({ modal }) => {
				modal.close();
				defer.reject({ needSupervisor });
			})
		}
		else {
			defer.resolve({ needSupervisor });
		}

		return defer.promise
	}

	commit() {
		const shipments = [];
		const currentDate = moment();
		const areAllShipmentsValid = this.model.shipments.every((shipmentRecord) => {
			return !!shipmentRecord.location;
		});
		this.releaseError = [];
		this.model.duplicateTrackingIds = [];

		if (!areAllShipmentsValid) {
			return console.error('some shipments does not have valid refIds');
		}

		let idStorePromise = this.$q.when();
		if (this.model.coinOnlyBatch) {
			idStorePromise = this.IdStoreService.incrementKey('COINONLYBATCH', this.model.shipments.length);
		}

		return idStorePromise.then((idStoreData) => {
			this.model.shipments.forEach((shipmentBatchRecord, index) => {
				let baseTrackingId = shipmentBatchRecord.trackingId;
				if (this.model.coinOnlyBatch && idStoreData) {
					let currentIdValue = parseInt(idStoreData.start) + index;
					baseTrackingId = currentIdValue.toString();
				}

				const uniqueShipmentFields = Object.keys(this.coinTypes);
				const days = {
					0: 'Sun',
					1: 'Mon',
					2: 'Tue',
					3: 'Wed',
					4: 'Thu',
					5: 'Fri',
					6: 'Sat'
				};
				const selectedDay = days[moment(this.model.deliveryDate).day()];
				const seqKey = 'defRouteSeq' + selectedDay;

				uniqueShipmentFields.forEach((field) => {
					if (typeof shipmentBatchRecord[field] === 'number' && shipmentBatchRecord[field] > 0) {
						const shiptypeId = this.coinTypes[field].selected;
						const coinFlag = !!this.coinTypes[field].coinFlag;
						shipments.push({
							pickupDate: moment(this.model.pickupDate).format('YYYY-MM-DD'),
							deliveryDate: moment(this.model.deliveryDate).format('YYYY-MM-DD'),
							vaultDate: moment(this.model.deliveryDate).format('YYYY-MM-DD'),
							fromLocationId: shipmentBatchRecord.refIdObj.parentLocation.id,
							// fromLocationId: this.model.location.id,
							toLocationId: shipmentBatchRecord.location.id,
							routeSeq: shipmentBatchRecord.location[seqKey] || 0,
							routeId: shipmentBatchRecord.routeId,
							batchId: 'B1-' + currentDate.toDate().getTime(),
							branchId: this.model.location.branchId,
							// branchId: this.model.branchId,
							coinFlag,
							trackingId: baseTrackingId + '-' + shiptypeId,
							amount: shipmentBatchRecord[field] * this.getCoinValue(shiptypeId),
							qty: shipmentBatchRecord[field],
							shiptypeId: shiptypeId,
							// orderNo: shipmentBatchRecord.trackingId,
							pickupFlag: false,
							packedFlag: true
						});
					}
				});

				//shipment for currency
				const cashAmount = this.getCurrency(index);

				if (typeof cashAmount === 'number' && cashAmount > 0) {
					shipments.push({
						pickupDate: moment(this.model.pickupDate).format('YYYY-MM-DD'),
						deliveryDate: moment(this.model.deliveryDate).format('YYYY-MM-DD'),
						vaultDate: moment(this.model.deliveryDate).format('YYYY-MM-DD'),
						fromLocationId: shipmentBatchRecord.refIdObj.parentLocation.id,
						// fromLocationId: this.model.location.id,
						toLocationId: shipmentBatchRecord.location.id,
						routeSeq: shipmentBatchRecord.location[seqKey] || 0,
						routeId: shipmentBatchRecord.routeId,
						batchId: 'B1-' + currentDate.toDate().getTime(),
						branchId: this.model.location.branchId,
						// branchId: this.model.branchId,
						trackingId: baseTrackingId,
						qty: 1,
						amount: cashAmount,
						shiptypeId: 'C',
						// orderNo: shipmentBatchRecord.trackingId,
						pickupFlag: false,
						packedFlag: true
					});
				}
			});

			return this.checkHoldAndCallSupervisor(shipments)
				.then(({ needSupervisor, supId }) => {
					return this.$q.all(shipments.map((shipment) => {
						if (shipment.routeId === 'HOLD') {
							shipment.routeId = this.HOLD_ROUTE;
							shipment.holdFlag = true;

							const holdDetails = {
								status: 'ON_HOLD',
								reason: "No Route Available/Selected",
								holdDate: moment(currentDate).format('YYYY-MM-DD'),
								supvHoldId: supId
							};

							return this.ShipmentService.create(shipment)
								.then((shipment) => {
									return this.ShipmentService.createHold(Object.assign({}, shipment, holdDetails))
								})
						}
						else {
							return this.ShipmentService.create(shipment)
						}
					}))
				})
				.then(() => {
					if (this.model.selectedFile) {
						return this.RouteService.removeUploadFile(this.model.selectedFile)
							.catch((err) => {
								console.error(err);
							});
					}
					else {
						return this.$q.when();
					}
				})
				.then((data) => {
					let successMessage = this.$translate.instant('commitSuccessModal.message');
					this.Modal.commitSuccessModal(this.getTotalByName('total'), 0, currentDate, successMessage, null, ({ modal }) => {
						modal.close();
						let releaseRoutes = _.chain(shipments).map(function (item) { return item.routeId }).uniq().value();
						this.executeReleaseRoutes(releaseRoutes, this.model.deliveryDate)
							.then(() => {
							})
							.catch((err) => {
								if (this.releaseError.length > 0) {
									let errorRoute = '';
									this.releaseError.map((err) => {
										if (errorRoute == '') {
											errorRoute = err.routeId
										} else {
											errorRoute += ', ' + err.routeId;
										}
										return;
									})
									this.Modal.errorModal(this.releaseError[0].message + ' ' + errorRoute);
								}
							});
						this.resetData();
					})
				})
				.catch((err) => {
					if (err && err.data && err.data.errors) {
						this.Modal.errorModal("error." + err.data.errors[0].path);
					}
					else if (err && err.data && err.data.message) {
						this.Modal.errorModal(err.data.message);
					}
					// console.error(err);
				});
		});
	}

	reset() {
		for (let key in this.model) {
			this.model[key] = ''
		}
		this.clearErrors()
	}

	submit(evt) {
		if (!this.validate()) {
			return
		}

		this.loading = true
		this.Service.create({
			id: this.model.id,
			description: this.model.description,
			inputType: this.model.inputType,
			batchSourceId: this.model.batchSourceId
		})
			.then((data) => {
				this.loading = false
				this.askCreate()
			})
			.catch((err) => {
				this.loading = false
				err.data.errors.map((e) => {
					this.errorMessage += e.message + '<br/>'
				})
			})
	}

	processFileData(model) {
		const previousShipments = angular.copy(this.model.shipments);
		// this.model.deliveryDate = new Date(model.selectedFile.fileData.deliveryDate);
		// this.model.pickupDate = new Date(model.selectedFile.fileData.pickupDate);
		this.model.deliveryDate = new Date(model.deliveryDate);
		this.model.pickupDate = new Date(model.pickupDate);
		this.model.location = model.location;
		this.model.batchMaster = model.batchMaster;
		this.model.selectedFile = model.selectedFile.fileName;
		this.model.description = this.model.selectedFile;
		this.deliveryDateOptions = {
			minDate: this.model.pickupDate
		};
		this.model.shipments = [];
		this.model.duplicateTrackingIds = [];

		let previewIdPromise = this.$q.when();
		let nextCoinTrackingId = null;
		if (this.model.coinOnlyBatch) {
			if (previousShipments && previousShipments.length && previousShipments[0].trackingId && !isNaN(parseInt(previousShipments[0].trackingId, 10))) {
				nextCoinTrackingId = parseInt(previousShipments[0].trackingId, 10);
			} else {
				nextCoinTrackingId = parseInt(this.model.currentCoinNumber, 10);
			}
			if (isNaN(nextCoinTrackingId)) {
				previewIdPromise = this.IdStoreService.getPreviewNextId('COINONLYBATCH', model.selectedFile.fileData.shipments.length + 1);
			}
		}

		return previewIdPromise.then((idStoreData) => {
			model.selectedFile.fileData.shipments.forEach((shipmentData, index) => {
				// at least one shipment entry should get created
				const firstCashBag = shipmentData.cashBags && shipmentData.cashBags[0];
				const cashSum = (firstCashBag && firstCashBag.value) || 0;
				const coinMappings = [
					{ modelField: 'coin1', fileField: 'pennyBagCount', category: 'PENNY' },
					{ modelField: 'coin5', fileField: 'nickelBagCount', category: 'NICKEL' },
					{ modelField: 'coin10', fileField: 'dimesBagCount', category: 'DIMES' },
					{ modelField: 'coin25', fileField: 'quarterBagCount', category: 'QUARTER' },
					{ modelField: 'coin1$', fileField: 'dollarBagCount', category: 'ONE_US_DOLLAR' }
				];

				//perform coin calculation only for the first cash bag
				const coinSum = coinMappings.reduce((partialSum, coinMapping) => {
					if (this.coinTypes[coinMapping.category]) {
						const coinType = this.coinTypes[coinMapping.category].selected;
						const coinValue = this.getCoinValue(coinType);
						const bagCount = shipmentData[coinMapping.fileField];

						return partialSum + (!!bagCount ? (bagCount * coinValue) : 0);
					}
				}, 0);

				if (this.model.coinOnlyBatch && coinSum === 0) {
					return;
				}

				let trackingId = null;
				if (this.model.coinOnlyBatch) {
					if (isNaN(nextCoinTrackingId) && idStoreData) {
						nextCoinTrackingId = parseInt(idStoreData.start, 10);
					}
					trackingId = nextCoinTrackingId.toString();
					nextCoinTrackingId++;
				} else {
					trackingId = (firstCashBag && firstCashBag.label) || shipmentData.location.id;
				}

				// if (cashSum > 0) {
				this.model.shipments.push({
					refId: shipmentData.location.id,
					locationName: shipmentData.location.name,
					locationAddress: shipmentData.location.address,
					total: this.model.coinOnlyBatch ? coinSum : cashSum,
					cashCoinTotal: this.model.coinOnlyBatch ? coinSum : cashSum,
					cashAmount: this.model.coinOnlyBatch ? 0 : cashSum,
					trackingId: trackingId,

					routeIds: [],

					coin1: shipmentData.pennyBagCount || null,
					coin5: shipmentData.nickelBagCount || null,
					coin10: shipmentData.dimesBagCount || null,
					coin25: shipmentData.quarterBagCount || null,
					coin1$: shipmentData.dollarBagCount || null,

					currency: this.model.coinOnlyBatch ? 0 : cashSum,
					scanLimit: this.scanLimit,
					amountErrors: {},
					checkScanLimit: this.scanLimit > 0
				});
				// }
				if (this.model.coinOnlyBatch) {
					return;
				}

				// remove first cash bag as it is already processed above
				const remainingCashBags = shipmentData.cashBags ? shipmentData.cashBags.slice(1) : [];
				remainingCashBags.forEach((cashBag) => {
					if (cashBag.label) {
						this.model.shipments.push({
							refId: shipmentData.location.id,
							locationName: shipmentData.location.name,
							locationAddress: shipmentData.location.address,
							total: this.model.coinOnlyBatch ? 0 : cashBag.value,
							cashCoinTotal: cashBag.value,
							cashAmount: cashBag.value,
							trackingId: cashBag.label,

							routeIds: [],

							// in case of multiple cash-bags ignore coins
							coin1: null,
							coin5: null,
							coin10: null,
							coin25: null,
							coin1$: null,

							currency: cashBag.value,
							scanLimit: this.scanLimit,
							amountErrors: {},
							checkScanLimit: this.scanLimit > 0
						})
					}
				});
			});

			if (this.model.coinOnlyBatch) {
				if (!isNaN(nextCoinTrackingId)) {
					this.model.currentCoinNumber = nextCoinTrackingId.toString();
				} else if (idStoreData) {
					this.model.currentCoinNumber = idStoreData.end.toString();
				}
			}

			if (!this.model.shipments.length) {
				if (this.model.coinOnlyBatch && previousShipments && previousShipments.length) {
					this.model.shipments = previousShipments;
				} else {
					this.add();
				}
			}

			// this.fromLocationChanged();

			this.model.expectedTotal = Math.round(model.selectedFile.fileData.totalAmount);
			this.model.cursor = model.selectedFile.fileData.autoGeneratedCursor;
			return this.setNewRoutes();
		});
	}

	selectUploadFile() {
		if (this.isDisabled) return;
		this.isDisabled = true;
		this.Modal.uploadedFileSelection(this.model.location,this.locations.filter((loc) => loc.id === this.model.location.id), this.batchMasters,this.model.branches, ({ modal, $scope }) => {
			this.processFileData($scope.model)
				.then(() => {
					return this.RouteService.getUploadedFiles();
				})
				.then((data) => {
					this.uploadedFiles = data.results;
				})
				.catch((err) => {
					if (err && err.data && err.data.message) {
						this.Modal.errorModal(err.data.message);
					}
					else {
						console.error(err);
					}
				})
				.finally(() => {
					this.isDisabled = false;
					modal.close();
				});
		}, ({ modal }) => {
			this.isDisabled = false;
			if (modal) modal.close();
		}, this.model.selectedFile);
	}

	changeType(event, type, coin) {
		this.coinTypes[type].selected = coin;
		this.coinTypes[type].isOpen = false;
	}

	isFirstShipmentCompleted() {
		const firstShipmentRecord = this.model.shipments && this.model.shipments[0];

		return firstShipmentRecord &&
			firstShipmentRecord.refId &&
			firstShipmentRecord.trackingId &&
			firstShipmentRecord.total &&
			firstShipmentRecord.routeId;
	}

	fromLocationChanged() {
		if (this.model.location) {
			const selectedBatchType = this.batchMasters.find((batchMaster) => {
				return batchMaster.batchSourceId === this.model.location.id;
			});

			if (this.model.batchMaster !== selectedBatchType.inputType) {
				this.model.batchMaster = selectedBatchType.inputType;
				// this.batchMasterChanged();
			}
			this.SetupService.get(this.model.location.branchId).then((res) => {
				this.setupData = res;
				this.autoGenerateToggle = this.setupData.autoGenerateTrackingId;
				setTimeout(() => {
					if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
						this.getPreviewId().then(() => {
							for (let i = 0; i < this.model.shipments.length; i++) {
								const data = this.model.shipments[i];
								data.trackingId =  this.setupData.trackingIdPrefix + this.currentNumberArray[i];
							}
						})
					}
					if(!this.autoGenerateToggle){
						this.model.shipments.forEach((data) => {
							this.trackingId = data.trackingId
						})
					}
					this.$scope.$apply()
				})
			})
		}

		if(this.model.location) {
			this.model.shipments.forEach((s) => {
				// const locBranches =  s.refIdObj && s.refIdObj.locationBranches ? s.refIdObj.locationBranches.map((br) => br.branchId) : [];
				// const branchIdExists = s.refIdObj && 
				// s.refIdObj.branchId === this.model.location.branchId || 
				// locBranches.includes(this.model.location.branchId);
				const branchIdExists = s.refIdObj && s.refIdObj.branchId === this.model.location.branchId;
				if (!branchIdExists) {
					s.refIdObj = null;
					s.refId = null;
					s.location = '';
					if(this.isRoutesSet || s.refIdObj) s.location = '';
				}
			})
		}
		this.bankLocationToggleChange();


	}

	createLocation(index) {
		const shipmentRecord = this.model.shipments[index];

		const locationModel = {
			id: shipmentRecord.refId,
			refId: shipmentRecord.refId,
			name: shipmentRecord.locationName,
			_address: shipmentRecord.locationAddress,
			branch: this.model.location.branchId
			// branch: this.model.branchId
		};

		this.Modal.addLocation(locationModel, ({ modal, data }) => {
			//close modal
			modal.close();

			//fetch route for selected record
			let dupplicatItemIndex = []
			this.model.shipments.map((item, i) => {
				if (item.refId == this.model.shipments[index].refId) {
					dupplicatItemIndex.push(i)
				}
			});
			this.setNewRoutes(dupplicatItemIndex);

			//hide popover for selected record if user has not change the refNumber
			if (shipmentRecord.refId == data.id || shipmentRecord.refId == data.refNumber) {
				this.model.shipments[index].popoverStatus = false;
			}
		}, ({ modal, err }) => {
			if (err && err.data.errors.length) {
				modal.close();
				err.data.errors.map((e) => {
					this.Modal.errorModal("error.locationCreateError");
				})
			} else {
				modal.close();
			}
		})
	}

	updateLocation(index, val) {
		const shipmentRecord = this.model.shipments[index];
		this.LocationService.update(shipmentRecord.suspendLocations.id, {
			id: shipmentRecord.suspendLocations.id,
			active: val ? 1 : 0
		})
			.then((data) => {
				this.setNewRoutes();
				this.model.shipments[index].popoverStatus = true;
				if (shipmentRecord.refId == data.id || shipmentRecord.refId == data.refNumber) {
					this.model.shipments[index].popoverStatus = false;
				}
			})
			.catch(error => {
				console.log(error);
			});
	}

	getAllLocation(searchKey, offset) {
		return
		let loadLocationDatas = '';
		if (searchKey) {
			this.offset = 0;
			loadLocationDatas = this.loadLocationDataWithSearch(searchKey);
		}
		else {
			if (offset == 0) {
				this.offset = 0;
			}
			loadLocationDatas = this.loadLocationData();
		}

		this.LocationService.getAllLocation(loadLocationDatas, this.offset, LIMIT)
			.then((data) => {
				if (this.offset === 0) {
					this.totalLocationRecords = data.total;
					this.locations = this.mappingLocationDatas(data.results).filter((location) => this.batchSourceIds.includes(location.id));
					this.offset += 10;
					if (this.locations.length <= 10 && !searchKey) {
						this.changeOffsetFlag = false;
						this.getAllLocation('', this.offset)
					}
				}
				else {
					const locations = this.mappingLocationDatas(data.results).filter((location) => this.batchSourceIds.includes(location.id));;
					this.locations = this.locations.concat(locations);
					this.offset += 10;
					if (this.locations.length <= 10) {
						this.changeOffsetFlag = false;
						if (this.totalLocationRecords > this.offset) {
							this.getAllLocation('', this.offset)
						}
					} else this.changeOffsetFlag = true
				}
			})
			.catch(error => {
				console.log(error);
			});
	}

	getAllBranchesList(searchKey, offset) {
		this.BranchService.all(searchKey, offset, MAXLIMIT)
			.then((data) => {
				const branches = this.mappingBranches(data.results);

				if (offset === 0) {
					this.totalBranchesRecords = data.total;
					this.branches = branches;
				} else {
					this.branches = [...this.branches, ...branches];
				}

				this.branches.forEach(branch => {
					const selectedBranches = this.model.branches.map(selectedbranch => selectedbranch.Value)
					if(!selectedBranches.length){
						if(branch.id === this.model.branchId){
							branch.ticked = true;
						}
						this.branchChanged();
						return;
					}
					if(selectedBranches.includes(branch.Value)){
						branch.ticked = true;
					}
				});
				this.model.branches = this.branches.filter(branch => branch.ticked);
				this.branchChanged();
			})
			.catch((err) => {
				console.error("Error fetching branches:", err);
			});
	}

	executeReleaseRoutes(routes, vaultDate) {
		let releaseRoutes = _.chain(this.model.shipments).map(function (item) { return item.routeId }).uniq().value();
		this.releaseError = [];
		const formattedDate = moment(this.model.deliveryDate).format('YYYY-MM-DD');

		return releaseRoutes.reduce((p, route) => {
			const nextIteration = this.$q.defer();
			p.then(() => {
				if (route !== 'HOLD') { //route !== this.HOLD_ROUTE // replace this when using old commit()
					this.RouteService.releaseRoute(route, formattedDate)
						.then((res) => {
							nextIteration.resolve();
						})
						.catch((err) => {
							const releaseRouteErrors = JSON.parse(err.data.message);
							releaseRouteErrors.routeId = route;
							this.releaseError.push(releaseRouteErrors);
							if (this.releaseError.length > 0) {
								let errorRoute = '';
								this.releaseError.map((err) => {
									if (err.routeId !== 'HOLD') {
										if (errorRoute == '') {
											errorRoute = err.routeId
										} else {
											errorRoute += ', ' + err.routeId;
										}
									}
									return;
								})
								if ((releaseRouteErrors.message == 'E_ROUTEDETAIL_DISABLED_MULTICHECKOUT') && (releaseRouteErrors.errorCode == '90000')) {
									let errMessage = this.$translate.instant('error.disabled_multi_checkout')
									this.Modal.errorModal(errorRoute + ' ' + errMessage);
								}
								else {
									this.Modal.errorModal(this.releaseError[0].message + ' ' + errorRoute);
								}
							}
						})
				} else {
					nextIteration.resolve();
				}
			})
			return nextIteration.promise;
		}, this.$q.when())
			.then(() => {
				return this.newCommit();
			})
	}

	setNewRoutes() {
		this.isRouteDisabled = true;
		this.routeLocations = [];
		this.allRouteLocations = [];
		const INDEX_NOT_MENTIONED = 'index not mentioned';
		this.errorCheck = 0;
		this.errorCount = 0;
		this.errorNotFound = 0;
		this.errorNotFoundCount = 0;
		this.errorLocSuspended = 0;
		this.errorLocSuspendedCount = 0;
		this.model.duplicateTrackingIds = [];
		const day = moment(this.model.deliveryDate).day();

		const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

		const routeIdField = `defRoute${weekDays[day]}Id`;
		const routeField = `defRoute${weekDays[day]}`;
		const holidayRouteId = 'defRouteHolId';
		const HolidayRoutes = 'defRouteHol';

		this.model.vaultDates = moment(this.vaultDate).day();

		// check for Holidays
		this.isHoliday.forEach((holidays) => {
			this.holidayStartDate = moment(holidays.holidayDate).day();
			this.holidayEndDate = moment(holidays.holidayEnd).day();
		})

		// check if holidayToggle true or false
		const useHolidays = this.holidayRoutes

		// check for routeId associate with different branch OR not && also check for Holiday Routes
		// if (this.model.vaultDates == day && this.model.vaultDates == this.holidayStartDate
		// 	&& this.model.location[HolidayRoutes] !== null
		// 	&& this.model.location[HolidayRoutes].branchId === this.model.branchId && useHolidays == true) {
		// 	this.routes.defaultRoute = this.model.location[holidayRouteId];
		// }
		// else if (day == this.holidayEndDate && this.holidayEndDate == this.model.vaultDates
		// 	&& this.model.location[HolidayRoutes] !== null
		// 	&& this.model.location[HolidayRoutes].branchId === this.model.branchId && useHolidays == true) {
		// 	this.routes.defaultRoute = this.model.location[holidayRouteId];
		// }
		// else if (this.model.location[routeField] && this.model.location[routeField].branchId === this.model.branchId) {
		// 	this.routes.defaultRoute = this.model.location[routeIdField];
		// }
		// else {
		// 	this.routes.defaultRoute = 'HOLD';
		// }
		if (this.model.vaultDates == day && this.model.vaultDates == this.holidayStartDate
			&& this.model.location[HolidayRoutes] !== null
			&& this.model.location[HolidayRoutes].branchId === this.model.location.branchId && useHolidays == true) {
			this.routes.defaultRoute = this.model.location[holidayRouteId];
		}
		else if (day == this.holidayEndDate && this.holidayEndDate == this.model.vaultDates
			&& this.model.location[HolidayRoutes] !== null
			&& this.model.location[HolidayRoutes].branchId === this.model.location.branchId && useHolidays == true) {
			this.routes.defaultRoute = this.model.location[holidayRouteId];
		}
		else if (this.model.location[routeField] && this.model.location[routeField].branchId === this.model.location.branchId) {
			this.routes.defaultRoute = this.model.location[routeIdField];
		}
		else {
			this.routes.defaultRoute = 'HOLD';
		}

		this.model.shipments.map((shipment, index) => {
			if ((!shipment.location) && shipment.refId && (shipment.trackingId || this.model.coinOnlyBatch) && shipment.total >= 0) {
				const parts = shipment.refId.split(' | ');
				this.routeLocations.push({
					'refId': parts[0].trim(),
					'branchId': shipment.refIdObj && shipment.refIdObj.parentLocation ? shipment.refIdObj.parentLocation.branchId : this.model.location.branchId
					// 'branchId': this.model.branchId
				})
			}
			if (shipment.refId && (shipment.trackingId || this.model.coinOnlyBatch) && shipment.total >= 0) {
				const parts = shipment.refId.split(' | ');
				this.allRouteLocations.push({
					'refId': parts[0].trim(),
					'branchId':shipment.refIdObj && shipment.refIdObj.parentLocation ? shipment.refIdObj.parentLocation.branchId : this.model.location.branchId
					// 'branchId': this.model.branchId
				})
			}
		})

		if (!this.routeLocations.length) {
			this.routeLocations = this.allRouteLocations;
			(this.model.shipments).forEach((item) => {
				delete (item.locations)
			})
		}

		if (this.routeLocations.length) {
			return this.LocationService.shipmentRoutes(this.routeLocations)
				.then((locationResponse) => {
					let locations = [];
					// this.isRouteDisabled = false;
					if (this.model.shipments.length && locationResponse.length) {
						let newIndex = 0;
						this.model.shipments.map((shipment, index) => {
							if(!shipment.refIdObj){
								shipment.refIdObj = {
									...shipment.refIdObj,
									...locationResponse[0],
									...(shipment.refIdObj ? {} : { parentLocation: this.model.location })
								};
							}
							shipment.isSuspended = false
							if (shipment.refId && (shipment.trackingId || this.model.coinOnlyBatch) && shipment.total >= 0) {
								if (shipment.location) { //already scan
									this.shipmentData = shipment.location;
									shipment.defaultBranch = shipment.branchId;
									shipment.isFromOtherBranch = true;
								} else if (locationResponse[newIndex] && !locationResponse[newIndex].active) {
									shipment.isSuspended = true;
									shipment.suspendStatus = false;
									shipment.defaultBranch = '';
									this.shipmentData = null;
									shipment.suspendLocations = locationResponse[newIndex];
									shipment.isFromOtherBranch = false;
									if (this.errorLocSuspendedCount == 0) {
										this.errorLocSuspendedCount = 1;
										this.Modal.errorModal("shipmentBatch.locationSuspended");
									}
									newIndex++;
								} else if (locationResponse[newIndex]) {
									this.shipmentData = locationResponse[newIndex];
									shipment.defaultBranch = locationResponse[newIndex].branchId;
									shipment.isFromOtherBranch = true;
									shipment.locObj = shipment.refId + ' | ' + this.shipmentData.name;
									shipment.refId = shipment.locObj;
									if (locationResponse[newIndex].locationBranches.length && !locationResponse[newIndex].locationBranches.includes(this.model.location.branchId)) {
										// if (locationResponse[newIndex].locationBranches.length && !locationResponse[newIndex].locationBranches.includes(this.model.branchId)) {
										this.shipmentData = null;
										this.errorCheck++;
										if (this.errorCheck >= 1 && this.errorCount == 0) {
											this.errorCount = 1
											this.Modal.errorModal("error." + 90222);
										}
									}
									newIndex++;
								} else {
									newIndex++;
									shipment.defaultBranch = '';
									this.shipmentData = null;
									shipment.isFromOtherBranch = false;
									this.errorNotFound++;
									if (this.errorNotFound >= 1 && this.errorNotFoundCount == 0) {
										this.errorNotFoundCount = 1
										this.Modal.errorModal("location.noLocations");
									}
								}
								shipment.location = this.shipmentData;
								locations.push(this.shipmentData);
							}
						})
					} else {
						this.model.shipments[0].isFromOtherBranch = false;
						this.shipmentData = null;
						this.model.shipments[0].location = null
						locations.push(this.shipmentData);
						this.errorNotFound++;
						if (this.errorNotFound >= 1 && this.errorNotFoundCount == 0) {
							this.errorNotFoundCount = 1
							this.Modal.errorModal("location.noLocations");
						}
					}
					return locations;
				})
				.then((locations) => {
					// this.isRouteDisabled = false;
					return locations.map((fetchedLocation) => {

						this.fetchedLocations = fetchedLocation;

						if (fetchedLocation === null || fetchedLocation === INDEX_NOT_MENTIONED) {
							return fetchedLocation;
						}
						// check for routeId associate with different branch OR not && also check for Holiday
						// if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null &&
						// 	this.model.vaultDates == this.holidayStartDate &&
						// 	fetchedLocation[HolidayRoutes].branchId === this.model.branchId &&
						// 	this.model.vaultDates == day && useHolidays == true) {
						// 	return fetchedLocation[holidayRouteId];
						// }
						// else if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null &&
						// 	day == this.holidayEndDate && this.holidayEndDate == this.model.vaultDates &&
						// 	fetchedLocation[HolidayRoutes].branchId === this.model.branchId &&
						// 	useHolidays == true) {
						// 	return fetchedLocation[holidayRouteId];
						// }
						// else if (fetchedLocation != null && fetchedLocation[routeField] !== null &&
						// 	fetchedLocation[routeField].branchId === this.model.branchId) {
						// 	return fetchedLocation[routeIdField];
						// }
						if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null &&
							this.model.vaultDates == this.holidayStartDate &&
							fetchedLocation[HolidayRoutes].branchId === this.model.location.branchId &&
							this.model.vaultDates == day && useHolidays == true) {
							return fetchedLocation[holidayRouteId];
						}
						else if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null &&
							day == this.holidayEndDate && this.holidayEndDate == this.model.vaultDates &&
							fetchedLocation[HolidayRoutes].branchId === this.model.location.branchId &&
							useHolidays == true) {
							return fetchedLocation[holidayRouteId];
						}
						else if (fetchedLocation != null && fetchedLocation[routeField] !== null &&
							fetchedLocation[routeField].branchId === this.model.location.branchId) {
							return fetchedLocation[routeIdField];
						}
					})
				})
				.then((routeIds) => {
					let routes = [];
					this.RouteService.getAllBranchRoutes(this.model.location.branchId, moment(this.model.deliveryDate).format('YYYY-MM-DD'))
						.then((res) => {
							this.isRouteDisabled = false;
							res.filter(function (field) {
								routes.push(field.routeId);
							});
							this.model.shipments.forEach((shipmentBatchRecord, index) => {
								if (routeIds[index] === INDEX_NOT_MENTIONED) {
									return;
								}

								const shipmentRoute = routeIds[index];

								shipmentBatchRecord.routeIds = [];

								if (this.routes.defaultRoute) {
									shipmentBatchRecord.routeIds.push(this.routes.defaultRoute);
									shipmentBatchRecord.routeId = this.routes.defaultRoute;
								}
								if (!this.HOLD_ROUTE || (this.fetchedLocations != null && this.fetchedLocations[routeField] === null && shipmentBatchRecord.location && shipmentBatchRecord.location.locationScheduleRecurringData.length > 0)) {
									for (let i = 0; i < shipmentBatchRecord.location.locationScheduleRecurringData.length; i++) {
										for (let j = 0; j < shipmentBatchRecord.location.locationScheduleRecurringData[i].nextOccurrence.length; j++) {
											this.routeId = shipmentBatchRecord.location.locationScheduleRecurringData[i].routeId;

											this.date1Ocurrence = moment(shipmentBatchRecord.location.locationScheduleRecurringData[i].nextOccurrence[j].next1Occurrence).utc().format('YYYY-MM-DD');
											this.date2Ocurrence = moment(shipmentBatchRecord.location.locationScheduleRecurringData[i].nextOccurrence[j].next2Occurrence).utc().format('YYYY-MM-DD');
											this.date3Ocurrence = moment(shipmentBatchRecord.location.locationScheduleRecurringData[i].nextOccurrence[j].next3Occurrence).utc().format('YYYY-MM-DD');
											const deliveryDate = moment.parseZone(this.model.deliveryDate).format('YYYY-MM-DD');
											if ((deliveryDate == this.date1Ocurrence ||
												deliveryDate == this.date2Ocurrence ||
												deliveryDate == this.date3Ocurrence)) {
												shipmentBatchRecord.routeIds.push(this.routeId);
												shipmentBatchRecord.routeId = this.routeId;
												break;
											}
										}
									}
								} else if (this.HOLD_ROUTE || this.fetchedLocations != null
									&& this.fetchedLocations[routeField] !== null
									&& this.fetchedLocations[routeField].branchId !== this.model.location.branchId) {
									shipmentBatchRecord.routeIds.push('HOLD');
									shipmentBatchRecord.routeId = 'HOLD';
								}
								if (shipmentRoute) {
									shipmentBatchRecord.routeIds.push(shipmentRoute);
									shipmentBatchRecord.routeId = shipmentRoute;
								}
								shipmentBatchRecord.routeIds = (shipmentBatchRecord.routeIds).concat(routes);
								//remove dupes
								shipmentBatchRecord.routeIds = shipmentBatchRecord.routeIds.filter((routeId, index, array) => {
									return array.indexOf(routeId) === index;
								});
							});
						})
				})
				.catch((err) => {
					this.isRouteDisabled = false;
					console.error(err);
					if (err && err.data && err.data.message) {
						this.Modal.errorModal(err.data.message);
					}
				})
				.finally(() => {
					// this.isRouteDisabled = false;
					this.isRoutesSet = this.model.shipments.every((shipmentRecord) => {
						return !!shipmentRecord.location;
					});
				});
		} else {
			this.isRouteDisabled = false;
			this.isRoutesSet = this.model.shipments.every((shipmentRecord) => {
				return !!shipmentRecord.location;
			});
		}
	}

	newCommit() {
		if (this.isCommitDisabled) return;
		const shipments = [];
		const currentDate = moment();
		const areAllShipmentsValid = this.model.shipments.every((shipmentRecord) => {
			return !!shipmentRecord.location;
		});
		this.releaseError = [];
		this.model.duplicateTrackingIds = [];

		if (!areAllShipmentsValid) {
			return console.error('some shipments does not have valid refIds');
		}
		this.isCommitDisabled = true;

		let promise = this.$q.when();
		if (this.model.coinOnlyBatch) {
			promise = this.IdStoreService.incrementKey('COINONLYBATCH', this.model.shipments.length)
				.then((res) => {
					this.model.shipments.forEach((s, i) => {
						s.trackingId = (res.start + i).toString();
					});
				});
		}

		return promise.then(() => {
			this.model.shipments.forEach((shipmentBatchRecord, index) => {
				const uniqueShipmentFields = Object.keys(this.coinTypes);
				const days = {
					0: 'Sun',
					1: 'Mon',
					2: 'Tue',
					3: 'Wed',
					4: 'Thu',
					5: 'Fri',
					6: 'Sat'
				};
				const selectedDay = days[moment(this.model.deliveryDate).day()];
				const seqKey = 'defRouteSeq' + selectedDay;

				uniqueShipmentFields.forEach((field) => {
					let type = this.coinTypes[field].categoryName;
					if (typeof shipmentBatchRecord[type] === 'number' && shipmentBatchRecord[type] > 0) {
						const shiptypeId = this.coinTypes[field].selected;
						const coinFlag = !!this.coinTypes[field].coinFlag;
						shipments.push({
							pickupDate: moment(this.model.pickupDate).format('YYYY-MM-DD'),
							deliveryDate: moment(this.model.deliveryDate).format('YYYY-MM-DD'),
							vaultDate: moment(this.model.deliveryDate).format('YYYY-MM-DD'),
							// fromLocationId: this.model.location.id,
							fromLocationId: shipmentBatchRecord.refIdObj.parentLocation.id,
							toLocationId: shipmentBatchRecord.location.id,
							routeSeq: shipmentBatchRecord.location[seqKey] || 0,
							routeId: shipmentBatchRecord.routeId,
							batchId: 'B1-' + currentDate.toDate().getTime(),
							branchId: this.model.location.branchId,
							coinFlag,
							trackingId: shipmentBatchRecord.trackingId + '-' + shiptypeId,
							amount: shipmentBatchRecord[type] * this.getCoinValue(shiptypeId),
							qty: shipmentBatchRecord[type],
							shiptypeId: shiptypeId,
							// orderNo: shipmentBatchRecord.trackingId,
							pickupFlag: false,
							packedFlag: true
						});
					}
				});

				//shipment for currency
				const cashAmount = this.getCurrency(index);

				if (!this.model.coinOnlyBatch && typeof cashAmount === 'number' && cashAmount > 0) {

					shipments.push({
						pickupDate: moment(this.model.pickupDate).format('YYYY-MM-DD'),
						deliveryDate: moment(this.model.deliveryDate).format('YYYY-MM-DD'),
						vaultDate: moment(this.model.deliveryDate).format('YYYY-MM-DD'),
						fromLocationId: shipmentBatchRecord.refIdObj.parentLocation.id,
						// fromLocationId: this.model.location.id,
						toLocationId: shipmentBatchRecord.location.id,
						routeSeq: shipmentBatchRecord.location[seqKey] || 0,
						routeId: shipmentBatchRecord.routeId,
						batchId: 'B1-' + currentDate.toDate().getTime(),
						branchId: this.model.location.branchId,
						// branchId: this.model.branchId,
						trackingId: shipmentBatchRecord.trackingId,
						qty: 1,
						amount: cashAmount,
						shiptypeId: 'C',
						// orderNo: shipmentBatchRecord.trackingId,
						pickupFlag: false,
						packedFlag: true
					});
				}
			});

			return this.checkHoldAndCallSupervisor(shipments)
				.then(({ needSupervisor, supId }) => {
					// let totalCursor = this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle ? this.trackingIdCursor  + this.model.shipments.length:''
					let totalCursor;
					if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle) {
						if (this.model.cursor > 0) totalCursor = this.trackingIdCursor + this.model.cursor
						else if(this.model.cursor === 0) totalCursor = this.trackingIdCursor
						else totalCursor = this.trackingIdCursor + this.model.shipments.length
					}
					// else totalCursor = ''
					let autoGenerateTrackIdToggle = this.autoGenerateToggle === true ? true: false;
					return this.ShipmentService.createShipments(shipments, supId, this.HOLD_ROUTE, this.model.location.branchId, autoGenerateTrackIdToggle, totalCursor)
					// return this.ShipmentService.createShipments(shipments, supId, this.HOLD_ROUTE, this.model.branchId, autoGenerateTrackIdToggle, totalCursor)
				})
				.then(() => {
					if (this.model.selectedFile) {
						return this.RouteService.removeUploadFile(this.model.selectedFile)
							.catch((err) => {
								console.error(err);
							});
					}
					else {
						return this.$q.when();
					}
				})
				.then((data) => {
					this.isCommitDisabled = false;
					let successMessage = this.$translate.instant('commitSuccessModal.message');
					this.Modal.commitSuccessModal(this.getTotalByName('total'), 0, currentDate, successMessage, null, ({ modal }) => {
						this.printBatch(shipments);
						modal.close();
						this.resetData();
					})
				})
				.catch((err) => {
					this.isCommitDisabled = false;
					if (this.model.coinOnlyBatch) {
						this.refreshCoinOnlyTrackingIds()
							.catch((refreshErr) => {
								console.error(refreshErr);
							});
					}
					if (err && err.data && err.data.errors) {
						this.Modal.errorModal("error." + err.data.errors[0].path);
					}
					else if (err && err.data && err.data.message) {
						if (err.data.message.startsWith('The tracking id provided <b>')) {
							let trackingIds = /<b>(.*?)<\/b>/g.exec(err.data.message)[1].trim().split(',');
							this.model.duplicateTrackingIds = trackingIds;
						}
						this.Modal.errorModal(err.data.message);
					}
				});
		});
	}

	printBatch(shipments) {
		let url = this.$state.href('printBatch');
		window.w = window.open(url, '_blank');
		window.w.printData = {
			trackingIds: shipments.map(d => d.trackingId)
			// pickupDate: moment(this.model.pickupDate).format('YYYY-MM-DD'),
			// deliveryDate:  moment(this.model.deliveryDate).format('YYYY-MM-DD')
		}
	}

	bankLocationToggleChange() {
		if (this.model.bankLocationDDToggle && (this.model.location && this.model.location.Value)) {
			this.getBankDeliverLocations()
		} else {
			this.bankLocationsObj = {
				offset: 0,
				limit: 5000,
				totalLocationRecords: 0,
				list: [],
				search: '',
				loadMore: this.loadMoreBankDeliverLocations
			}
		}
	}
	getBankDeliverLocations() {
		if (!this.model.location) {
			this.bankLocationToggleChange();
		} else {
			this.LocationService.getBankDeliverLocations(this.bankLocationsObj.search || '', this.model.location.branchId, this.model.location.Value, (this.bankLocationsObj.offset - 1) * this.bankLocationsObj.limit, this.bankLocationsObj.limit, null, true)
				.then((res) => {
					if (!this.bankLocationsObj.offset) {
						this.bankLocationsObj.list = this.mappingLocationDatas(res.locations);
						this.bankLocationsObj.totalLocationRecords = res.totalRecords;
					} else {
						let locations = this.mappingLocationDatas(res.locations)
						this.bankLocationsObj.list = this.bankLocationsObj.list.concat(locations)
					}
					this.bankLocationsObj.list.forEach((record) => {
						record.parentLocation = this.model.location
					})
				}).catch((err) => {
					console.log(err)
					if (err && err.data && err.data.errors) {
						this.Modal.errorModal("error." + err.data.errors[0].path);
					}
				})
		}
	}

	loadMoreBankDeliverLocations(search, offset) {
		self.bankLocationsObj.search = search || '';
		self.bankLocationsObj.offset = offset || 0;
		self.getBankDeliverLocations();
	}

	uploadBatchFile() {
		this.Modal.uploadFiles(({ modal, data }) => {
			this.ShipmentService.uploadBatchFiles(data)
				.then(() => {
					this.RouteService.getUploadedFiles()
						.then((data) => {
							this.uploadedFiles = data.results;
						});
				})
				.catch((err) => {
					if (err && err.data && err.data.message) {
						this.Modal.errorModal(err.data.message);
					}
				})
				.finally(() => {
					modal.close();
				})
		}, ({ modal }) => {
			if (modal) modal.close();
		})
	}

	tabSelection(selectedValue) {
		this.model.currentStats = selectedValue;
		if (selectedValue === this.stats.completedShipment) {
			this.model.date = moment().format('YYYY-MM-DD');
			this.model.searchText = null;
			this.completedShipment();
		}
	}

	newAtmLoads() {
		const lastRecord = _.last(this.atmLoadModel.atmLoadShipment);
		let nextOrderNo;

		if (!lastRecord) nextOrderNo = this.atmLoadModel.nextOrderNumber;
		else if (lastRecord) nextOrderNo = this.addOne(lastRecord.orderNo);

		this.Modal.atmLoadShipment(null, nextOrderNo, this.vaultDate, 'create', ({ modal, fundingSource, orderNo, location, route, vaultDate, orderType, denominations }) => {
			this.atmLoadModel.atmLoadShipment.push({
				fundingSource, orderNo, location, route, vaultDate, orderType, denominations
			})
			modal.close();
		}, ({ modal }) => {
			if (modal) modal.close();
		})
	}

	addOne(orderNo) {
		let newOrderNumber = '';
		let continueAdding = true;
		for (let i = orderNo.length - 1; i >= 0; i--) {
			if (continueAdding) {
				let num = parseInt(orderNo[i], 10) + 1;
				if (num < 10) {
					newOrderNumber += num;
					continueAdding = false;
				} else {
					newOrderNumber += '0';
				}
			} else {
				newOrderNumber += orderNo[i];
			}
		}
		return newOrderNumber.split("").reverse().join("");
	}

	editAtmLoad(shipments, index) {
		this.Modal.atmLoadShipment(shipments, shipments.orderNo, this.vaultDate, 'edit', ({ modal, fundingSource, orderNo, location, route, vaultDate, orderType, denominations }) => {
			this.atmLoadModel.atmLoadShipment[index] = {
				fundingSource, orderNo, location, route, vaultDate, orderType, denominations
			}
			modal.close();
		}, ({ modal }) => {
			if (modal) modal.close();
		})
	}

	getOrderType(type) {
		switch (type) {
			case type: return this.$translate.instant('atm_residual.order_type_' + type);
			default: return '';
		}
	}

	resetAtmLoads() {
		this.Modal.confirm({
			header: this.$translate.instant('common.reset'),
			message: this.$translate.instant('shipmentBatch.resetData'),
			callback: ({
				modal
			}) => {
				this.atmLoadModel.atmLoadShipment = [];
				modal.close();
			},
			type: 'danger'
		})
	}

	deleteAtmLoad(shipment, index) {
		this.Modal.confirm({
			header: this.$translate.instant('common.confirm_delete_title'),
			message: this.$translate.instant('shipmentBatch.delete_message'),
			callback: (({
				modal,
				$scope
			}) => {
				this.atmLoadModel.atmLoadShipment.splice(index, 1);
				modal.close();
			}),
			type: 'danger'
		})
	}

	createAtmLoads() {
		let shipments = [], totalAmount = 0;
		this.atmLoadModel.atmLoadShipment.forEach((data) => {
			let keys = [], denoms = [];
			keys = Object.keys(data.denominations);
			keys.forEach((key) => {
				totalAmount += data.denominations[key].amount;
				denoms.push(data.denominations[key]);
			})

			shipments.push({
				fundingSourceId: data.fundingSource.Value,
				orderNo: data.orderNo,
				locationId: data.location.Value,
				routeId: data.route.Value,
				deliveryDate: moment(data.vaultDate).format('YYYY-MM-DD'),
				vaultDate: moment(data.vaultDate).format('YYYY-MM-DD'),
				orderType: data.orderType,
				denominations: denoms,
				createdByUserId: this.loggedInUserId,
				branchId: this.model.branchId,
				// branchId: this.model.branchId,
				fromLocationId: data.fundingSource.dataObj['locationId'],
				sourceName: data.fundingSource.dataObj['sourceName']
			})
		})

		this.atmLoadModel.isCreatingAtmOrders = true;
		this.OrderViewService.createAtmLoadShipments(shipments)
			.then((res) => {
				this.Modal.commitSuccessModal(totalAmount, null, new Date(), 'Shipment Successfully Created', null, ({ modal }) => {
					modal.close();
					this.atmLoadModel.atmLoadShipment = [];
				})
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.Modal.errorModal(err.data.message);
				}
			})
			.finally(() => {
				this.atmLoadModel.isCreatingAtmOrders = false;
			})
	}


	getAutoGeneratedTrackingId(cursor) {
		this.model.isGenerateTrackingIdLoading = true;
		let branchId = this.model.location ? this.model.location.branchId : this.model.branchId;
		return this.SetupService.getAutoGeneratedTrackingId(branchId, cursor)
			// return this.SetupService.getAutoGeneratedTrackingId(this.model.branchId, cursor)
			.then((data) => {
				this.currentNumber = data.currentTrackingIdNumber;
				this.incrementNumber = data.incrementTrackingIdNumber;
				this.trackingIdCursor = data.trackingIdCursor;
				this.currentNumberArray = data.currentNumberArray;
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.model.isGenerateTrackingIdLoading = false;
			})
	}

	getAutoGeneratedCoinId(amount) {
		const currentCoinIds = (this.model.shipments || [])
			.map((shipment) => parseInt(shipment.trackingId, 10))
			.filter((trackingId) => !isNaN(trackingId));

		if (currentCoinIds.length) {
			this.model.currentCoinNumber = (Math.max.apply(null, currentCoinIds) + 1).toString();
			return this.$q.when();
		}

		this.model.isGenerateTrackingIdLoading = true;
		return this.IdStoreService.getPreviewNextId('COINONLYBATCH', amount + 1)
			.then((data) => {
				this.model.currentCoinNumber = data.end.toString();
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.model.isGenerateTrackingIdLoading = false;
			})
	}

	getPreviewId() {
		let cursor;
		if (this.autoGenerateToggle) {
			if (this.deletedTrackingId && this.deletedTrackingId.length == 1) {
				cursor = this.model.shipments.length + 1;
			}
			else if (this.deletedTrackingId && this.deletedTrackingId.length > 1) {
				cursor = this.deletedTrackingId.length + this.model.shipments.length;
			}
			else {
				cursor = this.model.shipments.length - 1;
			}

			return this.getAutoGeneratedTrackingId(cursor);
		}
	}

	autoGenerateTrackingToggleChange() {
		if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
			this.getPreviewId()
				.then(() => {
					let trackingIdPrefix = this.setupData.trackingIdPrefix;
					let trackingIdNumber = this.currentNumber;

					this.currentTrackingNumber = trackingIdPrefix + trackingIdNumber;

					for (let i = 0; i < this.model.shipments.length; i++) {
						const data = this.model.shipments[i];
						data.trackingId = trackingIdPrefix + this.currentNumberArray[i];
					}
				})
				.catch((err) => {
					console.log(err);
				})
		}
	}

	printLabels() {
		this.shipmentDetails = []
		this.model.shipments.forEach((d) => {
			this.shipmentDetails.push({
				trackingId: d.trackingId,
				locationId: d.refId && d.refIdObj ? d.refIdObj.Value : d.refId ? d.refId.split('|')[0].trim() : d.refIdObj ? d.refIdObj.Value : null,
				branchId: d.refIdObj ? d.refIdObj.branchId : null,
				locationType: this.model.bankLocationDDToggle === true ?
					(d.refIdObj ? d.refIdObj.locationType === 'ON_CALL' ? 'ONC' :(d.refIdObj.locationType === 'REGULAR' ? 'REG' : d.refIdObj.locationType) : null) :
					(d.location && d.location.locationType === 'ON_CALL' ? 'ONC' : (d.location && d.location.locationType === 'REGULAR' ? 'REG' : d.location && d.location.locationType)),
					 locationName: this.model.bankLocationDDToggle === true ? (d.refIdObj ? d.refIdObj.name : null): d.location && d.location.name,
				// locationAddress: d.location ? d.location.address + ", " + d.location.city + ", " + d.location.state + ", " + d.location.zip : '',
				routeId: d.routeId,
				total: d.total,
				deliveryDate: moment(this.model.deliveryDate).format('DD-MMM-YYYY')
			});
		});

		const obj = {
			shipmentDetails: this.shipmentDetails
		}

		const path = this.$state.href('printBatch');
		window.w = window.open(path, '_blank');
		window.w.printData = obj;
	}

	dateChange() {
		this.model.searchText = '';
		this.pagination.page = 1;
		this.completedShipment();
	}

	pageChange() {
		this.completedShipment();
	}

	search() {
		this.pagination.page = 1;
		this.completedShipment();
	}

	sortData = (column) => {
		this.model.reverseSort = (this.model.sortColumn == column) ? !this.model.reverseSort : true;
		this.model.sortColumn = column;
		this.completedShipment();
	}

	completedShipment() {
		setTimeout(() => {
			this.model.loading = true;
			const searchText = this.model.searchText;
			return this.ShipmentService.completedShipments(this.model.branchId, moment(this.model.date).format('YYYY-MM-DD'), (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit, searchText, this.model.reverseSort, this.model.sortColumn)
				// return this.ShipmentService.completedShipments(this.model.branchId, moment(this.model.date).format('YYYY-MM-DD'), (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit, searchText, this.model.reverseSort, this.model.sortColumn)
				.then((data) => {
					this.pagination.loading = false;
					this.shipment = data;
					this.pagination.total = data.total.totalRecord;
				})
				.catch((err) => {
					console.log(err);
					if (err && err.data && err.data.message) {
						this.Modal.errorModal(err.data.message);
					}
				})
				.finally(() => {
					this.model.loading = false;
				})
		}, 100)
	}

	printCompleteShipmentLabels(batchId, locationId) {
		let url = this.$state.href('printBatch');
		window.w = window.open(url, '_blank');
		window.w.printCompletedShipmentData = {
			batchId: batchId,
			locationId: locationId
		}
	}

	selectAllBranches(){
		this.model.branches = this.branches;
		this.branchChanged();
	}

	branchChanged(){

		const branches = this.model.branches ? this.model.branches.map((ele) => ele.Value) : [this.model.branchId];
		if (this.model.location) {

			if (!branches || !branches.length) {
				this.model.location = null;
				this.locations = [];
				this.fromLocationChanged();
				return;
			}

			const branchExists = branches.some(
				branchId => branchId === this.model.location.branchId
			);

			if (!branchExists) {
				this.model.location = null;
				this.fromLocationChanged();
			}
		}

		if(!branches.length){
			this.locations = [];
			return
		}

		let batchSearchObj = {
			branchId: branches,
			queryText: '%%'
		}

		this.fetchBatchServiceData(batchSearchObj).then((res) => {
			this.batchSourceIds = res.results
				.filter((batch) => !!batch.batchSourceId)
				.map((batch) => batch.batchSourceId);

			this.locations =this.mappingLocationDatas(res.results.map(res => res.batchSource)).filter((location) => this.batchSourceIds.includes(location.id) && location.centralBank)
			this.batchMasters = res.results;
		})

		setTimeout(() => {
			this.getAllLocation('',0);
		}, 200)

		this.getBankDeliverLocations();
	}

	fetchBatchServiceData(searchObj){
		return this.BatchService.all(searchObj, 0, MAXLIMIT);
	}

	fetchLocationDetails(locationId){
		return this.ShipmentService.getShipmentLocationDetails(locationId);
	}
}

export default ShipmentBatchController;



// WEBPACK FOOTER //
// ./client/app/components/shipment_batch/shipment_batch.controller.js